import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import CustomerList from '@/components/CustomerList'
import Customer from '@/components/Customer'
import CustomerAdd from '@/components/CustomerAdd'
import CustomerEdit from '@/components/CustomerEdit'
import ContactAdd from '@/components/ContactAdd'
import ContactEdit from '@/components/ContactEdit'
import ContactDelete from '@/components/ContactDelete'
import NoteAdd from '@/components/NoteAdd'
import NoteEdit from '@/components/NoteEdit'
import NoteDelete from '@/components/NoteDelete'
import NotificationAdd from '@/components/NotificationAdd'
import NotificationEdit from '@/components/NotificationEdit'
import NotificationDelete from '@/components/NotificationDelete'
import OutlookContactSearch from '@/components/OutlookContactSearch'
import OutlookContactAdd from '@/components/OutlookContactAdd'
import ContactList from '@/components/ContactList'
import Error from '@/components/Error'
import Login from '@/components/Login'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '/login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (store.state.isAuthenticated) {
          next('/')
        } else {
          next()
        }
      }
    },

    {
      path: '/',
      redirect: '/customers',
    },

    {
      path: '/customers',
      name: 'customers',
      component: CustomerList,
      meta: { authRequired: true }
    },

    {
      path: '/customers/add',
      name: 'customer-add',
      component: CustomerAdd,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customers/:id',
      name: 'customer',
      component: Customer,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customer/edit/:id',
      name: 'customer-edit',
      component: CustomerEdit,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customer/:custId/contact/add',
      name: 'contact-add',
      component: ContactAdd,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/contact/edit/:id',
      name: 'contact-edit',
      component: ContactEdit,
      meta: { authRequired: true }
    },

    {
      path: '/contact/delete/:id',
      name: 'contact-delete',
      component: ContactDelete,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customer/:id/note/add',
      name: 'note-add',
      component: NoteAdd,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customer/:custId/note/edit/:id',
      name: 'note-edit',
      component: NoteEdit,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customer/:custId/note/delete/:id',
      name: 'note-delete',
      component: NoteDelete,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customers/:id/notifications/add',
      name: 'notification-add',
      component: NotificationAdd,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customers/:custId/notifications/edit/:id',
      name: 'notification-edit',
      component: NotificationEdit,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customers/:custId/notifications/delete/:id',
      name: 'notification-delete',
      component: NotificationDelete,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customers/:id/add-outlook-contact',
      component: OutlookContactSearch,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/customers/:custId/add-outlook-contact/:id',
      component: OutlookContactAdd,
      props: true,
      meta: { authRequired: true }
    },

    {
      path: '/contacts',
      component: ContactList,
      meta: { authRequired: true }
    },

    {
      path: '*',
      name: 'error',
      component: Error
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.isAuthenticated) {
      next({ path: '/login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js